<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row>
      <el-input
        v-model="search.openApiKeyWord"
        clearable
        size="small"
        placeholder="API名称或编码关键字"
        class="w-200px mr-10px"
      ></el-input>
      <el-input
        v-model="search.applyApplicationName"
        clearable
        size="small"
        placeholder="申请应用"
        class="w-200px mr-10px"
      ></el-input>
      <el-date-picker
        v-model="search.time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        class="mr-10px"
      >
      </el-date-picker>
      <el-button type="primary" size="small" @click="searchTableData">搜索</el-button>
    </el-row>
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      class="mt-20px"
      height="calc(100% - 107px)"
    >
      <el-table-column label="API名称" prop="openApiName" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="应用名称"
        prop="applyApplicationName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="请求IP地址" prop="ipAddresss" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="请求方法"
        prop="requestMethod"
        width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="API路径"
        prop="requestAddress"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="调用结果" prop="result" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="耗时(ms)"
        prop="timing"
        width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="记录保存时间"
        prop="creationTime"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="requestParams(scope.row.id)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px"
      background
      @size-change="searchTableData()"
      @current-change="findTableData()"
      :current-page.sync="page.pageNo"
      :page-sizes="$pageSizeAll"
      :page-size.sync="page.pageSize"
      layout="->, total, sizes, prev, pager, next"
      :total="page.pageTotal"
    ></el-pagination>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      width="800px"
      v-dialogDrag
      class="addMapping"
    >
      <div class="h-320px overflow-hidden mb-10px">
        <div>请求参数</div>
        <codemirror ref="myCm" v-model="request" :options="cmOptions" class="h-300px"></codemirror>
      </div>
      <div class="h-320px overflow-hidden">
        <div>请求结果</div>
        <codemirror ref="myCm" v-model="response" :options="cmOptions" class="h-300px"></codemirror>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { OpenApiCallRecordApi } from '@wiz-api/open-api-management'
import { codemirror } from 'vue-codemirror'
import dayjs from 'dayjs'

const openApiCallRecordApi = new OpenApiCallRecordApi()
export default {
  name: 'callLogging',
  components: {
    codemirror,
  },
  data() {
    return {
      search: {
        openApiKeyWord: '',
        applyApplicationName: '',
        time: [],
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      tableData: [],
      loading: false,
      request: '',
      response: '',
      dialogTitle: '详情',
      showDialog: false,
      cmOptions: {
        tabSize: 4,
        mode: 'application/json',
        theme: 'base16-light',
        lineNumbers: true,
        lineWrapping: true,
        lineWiseCopyCut: true,
        showCursorWhenSelecting: true,
        matchBrackets: true,
        line: false,
        styleActiveLine: true,
        autoRefresh: true,
        connect: 'align',
        readOnly: false,
      },
    }
  },
  computed: {
    isJumpRequest() {
      return this.$route.query.isJumpRequest || ''
    },
    isSuccess() {
      return this.$route.query.isSuccess || ''
    },
    jumpRequestType() {
      return this.$route.query.jumpRequestType || ''
    },
  },
  methods: {
    async findTableData() {
      this.loading = true
      const params = {
        openApiKeyWord: this.search.openApiKeyWord,
        applyApplicationName: this.search.applyApplicationName,
        startTime: this.search.time && this.search.time.length ? this.search.time[0] : null,
        endTime: this.search.time && this.search.time.length ? this.search.time[1] : null,
        sorting: '',
        skipCount: this.page.pageNo,
        maxResultCount: this.page.pageSize,
      }
      if (this.isJumpRequest) {
        params.isJumpRequest = this.isJumpRequest === 'true'
      }
      if (this.isSuccess) {
        params.isSuccess = this.isSuccess === 'true'
      }
      if (this.jumpRequestType) {
        params.jumpRequestParams = JSON.parse(localStorage.getItem('callLogParams'))
        params.jumpRequestType = Number(this.jumpRequestType)
      }
      const [err, res] = await openApiCallRecordApi.getList({ body: params })
      this.loading = false
      if (!err) {
        this.tableData = _.map(res.items, (item) => {
          item.creationTime = dayjs(new Date(item.creationTime)).format('YYYY-MM-DD HH:mm:ss')
          return item
        })
        this.page.pageTotal = res.totalCount
      }
    },
    searchTableData() {
      this.page.pageNo = 1
      this.findTableData()
    },
    // 请求参数传0，请求结果传1
    async requestParams(id) {
      this.showDialog = true
      const [err, res] = await openApiCallRecordApi.getApiCallDetailInfo(id)
      if (!err) {
        this.request = res.request
        this.response = res.response
      }
    },
  },
  created() {
    this.searchTableData()
  },
  activated() {
    this.searchTableData()
  },
}
</script>
